import { durableGetItem, durableSetItem } from './durableStorage';

const KEY = 'PRINT_ON_PLACED_SENT';
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

type SentMap = Record<string, number>;

let cache: SentMap | null = null;

function load(): SentMap {
    if (cache) return cache;
    const raw = durableGetItem(KEY);
    if (!raw) {
        cache = {};
        return cache;
    }
    try {
        const parsed = JSON.parse(raw) as SentMap;
        cache =
            typeof parsed === 'object' && parsed && !Array.isArray(parsed)
                ? parsed
                : {};
    } catch {
        cache = {};
    }
    return cache;
}

function save(map: SentMap) {
    cache = map;
    durableSetItem(KEY, JSON.stringify(map));
}

function prune(map: SentMap, now = Date.now()): SentMap {
    const cutoff = now - MAX_AGE_MS;
    const next: SentMap = {};
    for (const [id, ts] of Object.entries(map)) {
        if (typeof ts === 'number' && ts >= cutoff) {
            next[id] = ts;
        }
    }
    return next;
}

export function wasPrintOnPlacedSent(storeOrderId: string): boolean {
    const map = prune(load());
    return map[storeOrderId] != null;
}

export function markPrintOnPlacedSent(storeOrderId: string): void {
    const now = Date.now();
    const map = prune(load(), now);
    map[storeOrderId] = now;
    save(map);
}
